import { ethers } from "ethers";

// ABI
const abi = [
    "function approve(address spender, uint256 amount) public returns (bool)",
    "function allowance(address owner, address spender) public view returns (uint256)"
];


//获取rpc对象
async function get_RPC(RPC_url){
    const provider = new ethers.JsonRpcProvider(RPC_url, {
        chainId: 8453,
        name: "Base"
    });
    
    // 移除所有事件监听器
    provider.removeAllListeners();
    
    return provider;
}

//获取钱包对象
async function get_wallet(privateKey,RPC_url){
    const provider = await get_RPC(RPC_url);
    return new ethers.Wallet(privateKey, provider); // 确保 Wallet 与 Provider 绑定
}



//使用私钥导出公钥，要求输入钱包对象
async function get_publicKey(privateKey,RPC_url){
    const wallet = await get_wallet(privateKey, RPC_url);
    return wallet.address;
}

//获取合约对象，要求输入合约地址，abi
async function get_contract(contract_addr, abi, privateKey, RPC_url) {
    const wallet = await get_wallet(privateKey, RPC_url);
    return new ethers.Contract(contract_addr, abi, wallet);
}

//购买授权函数，默认无限授权所以不用
async function buy_approve(){
    //
}






//购买指定数量，输入池子地址、子币合约abi，私钥、RPC，购买所需virtual币数量，子币地址
//其中池子默认为0xF66DeA7b3e897cD44A5a231c61B6B4423d613259，virtual_amount为非BigNumber形式
async function buy(pool_addr="0xF66DeA7b3e897cD44A5a231c61B6B4423d613259",abi=["function buy(uint256 amountIn, address tokenAddress)"],privateKey,RPC_url,virtual_amount,subtoken_constract_addr){
    const contract = await get_contract(pool_addr,abi,privateKey,RPC_url);
    
    // 使用 parseUnits 替代 ethers.utils.parseUnits
    // 在 ethers v6 中，parseUnits 直接在 ethers 对象上
    const amountIn = ethers.parseUnits(virtual_amount.toString(), 18);
    
    const tx = await contract.buy(amountIn, subtoken_constract_addr);
    console.log("购买已发送，","数量",virtual_amount,"virtual，交易哈希:", tx.hash,"等待区块确认中");
    
    const receipt = await tx.wait();
    console.log("✅交易已确认，区块哈希:", receipt.blockHash);
}








//卖出授权函数，要求输入子币地址，spender，allowance
//其中spender所有地址默认为0x8292b43ab73efac11faf357419c38acf448202c5，allowance默认为无限
async function sell_approve(subtoken_constract_addr,abi=["function approve(address spender, uint256 amount) public returns (bool)"],privateKey,RPC_url,spender="0x8292b43ab73efac11faf357419c38acf448202c5",allowance=ethers.MaxUint256) {
    const contract = await get_contract(subtoken_constract_addr,abi,privateKey,RPC_url);
    const tx = await contract.approve(spender, allowance);
    
    console.log("卖出授权已发送，交易哈希:", tx.hash,"等待区块确认中");
    
    const receipt = await tx.wait();
    console.log("✅卖出授权已确认，区块哈希:", receipt.blockHash);
}



//卖出指定数量
async function sell(pool_addr="0xF66DeA7b3e897cD44A5a231c61B6B4423d613259",abi=["function sell(uint256 amountIn, address tokenAddress)"],privateKey,RPC_url,subtoken_amount,subtoken_constract_addr){
    const contract = await get_contract(pool_addr,abi,privateKey,RPC_url);
    
    // 使用 parseUnits 替代 ethers.utils.parseUnits
    // 在 ethers v6 中，parseUnits 直接在 ethers 对象上
    const amount_out = ethers.parseUnits(subtoken_amount.toString(), 18);
    
    const tx = await contract.sell(amount_out, subtoken_constract_addr);
    console.log("出售已发送，","数量",subtoken_amount,"交易哈希:", tx.hash,"等待区块确认中");
    
    const receipt = await tx.wait();
    console.log("✅交易已确认，区块哈希:", receipt.blockHash);
    
}


//判断购买授权量，即virtual授权量，要求输入公钥、spender，其中spender所有地址默认为0x8292b43ab73efac11faf357419c38acf448202c5
//默认无限授权，所以用不到
async function buy_allowance(privateKey, RPC_url, spender="0x8292b43ab73efac11faf357419c38acf448202c5") {
    const provider = await get_RPC(RPC_url);
    const wallet = new ethers.Wallet(privateKey, provider);
    const pool_spender_addr = "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b";
    const abi = [
        "function allowance(address owner, address spender) public view returns (uint256)"
    ];
    
    const contract = new ethers.Contract(pool_spender_addr, abi, wallet);
    const owner = await wallet.getAddress();
    
    return await contract.allowance(owner, spender);
}

//判断卖出授权量，即子币授权量，要求输入私钥、RPC、子币合约地址、spender
//其中spender所有地址默认为0x8292b43ab73efac11faf357419c38acf448202c5
async function sell_allowance(privateKey, RPC_url, subtoken_contract_addr, spender="0x8292b43ab73efac11faf357419c38acf448202c5") {
    const provider = await get_RPC(RPC_url);
    const wallet = new ethers.Wallet(privateKey, provider);
    const abi = [
        "function allowance(address owner, address spender) public view returns (uint256)"
    ];
    
    const contract = new ethers.Contract(subtoken_contract_addr, abi, wallet);
    const owner = await wallet.getAddress();
    
    return await contract.allowance(owner, spender);
}

//购买指定数量，输入池子地址、子币合约abi，私钥、RPC，购买所需virtual币数量，子币地址
//其中池子默认为0xF66DeA7b3e897cD44A5a231c61B6B4423d613259，virtual_amount为非BigNumber形式
async function buy_main(pool_addr="0xF66DeA7b3e897cD44A5a231c61B6B4423d613259",abi=["function buy(uint256 amountIn, address tokenAddress)"],privateKey,RPC_url,virtual_amount,subtoken_constract_addr){
    //由于默认无限授权，只需购买即可
    buy(pool_addr="0xF66DeA7b3e897cD44A5a231c61B6B4423d613259",abi=["function buy(uint256 amountIn, address tokenAddress)"],privateKey,RPC_url,virtual_amount,subtoken_constract_addr)
}

//查询指定地址的代币余额，输入代币合约地址、ABI、私钥、RPC地址
async function get_token_balance(token_contract_addr, abi=["function balanceOf(address account) view returns (uint256)"], privateKey, RPC_url) {
    // 添加时间戳到日志中，确保每次调用都产生新的日志
    console.log(`开始查询余额... (${new Date().toISOString()})`);
    
    // 获取合约对象
    const contract = await get_contract(token_contract_addr, abi, privateKey, RPC_url);
    
    // 获取钱包地址
    const address = await get_publicKey(privateKey, RPC_url);
    
    // 调用 balanceOf 方法获取余额
    const balance = await contract.balanceOf(address);
    
    // 将余额转换为更易读的格式（从wei转换为标准单位）
    const formatted_balance = ethers.formatUnits(balance, 18);
    
    console.log(`👀地址 ${address} 的代币余额为: ${formatted_balance}`);
    return formatted_balance;
}

async function partial_sell(pool_addr="0xF66DeA7b3e897cD44A5a231c61B6B4423d613259", 
    abi=["function sell(uint256 amountIn, address tokenAddress)"],
    privateKey,
    RPC_url,
    per,
    subtoken_contract_addr) {
    
    // 验证 per 参数是否在有效范围内
    if (per <= 0 || per > 1) {
        throw new Error("per 参数必须在 0 到 1 之间");
    }

    // 获取代币余额
    const balance = await get_token_balance(
        subtoken_contract_addr,
        ["function balanceOf(address account) view returns (uint256)"],
        privateKey,
        RPC_url
    );

    // 计算要卖出的数量
    const amount_to_sell = parseFloat(balance) * per;

    // 调用 sell 函数执行卖出操作
    await sell(
        pool_addr,
        abi,
        privateKey,
        RPC_url,
        amount_to_sell.toString(),
        subtoken_contract_addr
    );
}

// 使用 ES Module 导出语法
export {
    get_token_balance,
    buy_main,
    sell_main,
    get_publicKey,
    sell_approve,
    sell,
    partial_sell
};

async function sell_main(subtoken_contract_addr, subtoken_amount, privateKey, RPC_url, pool_addr = "0xF66DeA7b3e897cD44A5a231c61B6B4423d613259") {
    try {
        // 检查授权额度
        const allowance = await sell_allowance(privateKey, RPC_url, subtoken_contract_addr);
        // 使用字符串转换避免 BigInt 的 ESLint 错误
        const compareAllowance = ethers.getBigInt("11579208923731619542357098500868790785326998466564056403945758400791312963993");

        // 如果授权额度小于指定值，进行授权
        if (ethers.getBigInt(allowance.toString()) < compareAllowance) {
            console.log("当前授权额度不足，正在进行授权...");
            console.log("当前授权额度：", allowance.toString());
            await sell_approve(
                subtoken_contract_addr,
                ["function approve(address spender, uint256 amount) public returns (bool)"],
                privateKey,
                RPC_url
            );
            console.log("授权完成");
        } else {
            console.log("授权额度充足，无需重新授权");
        }

        // 执行卖出操作
        console.log("开始执行卖出操作...");
        await sell(
            pool_addr,
            ["function sell(uint256 amountIn, address tokenAddress)"],
            privateKey,
            RPC_url,
            subtoken_amount,
            subtoken_contract_addr
        );
    } catch (error) {
        console.error("交易失败:", error.message);
        if (error.error) {
            console.error("详细错误:", error.error);
            console.log("代币可能未授权");
        }
        throw error;
    }
}